import * as CONSTANTS from '../../shared/constants';

const { GRID_SIZE, PLAYER_COLORS, RENDER_DELAY } = CONSTANTS;

export const renderBombs = (
  ctx, 
  bombs, 
  bombImage, 
  bombSVGText,
  coloredBombCache,
  createColoredBomb,
  bombStateBuffers,
  interpolatePosition
) => {
  // Pre-calculate animation values once per frame
  const now = Date.now();
  const breathingNormal = 1 + Math.sin(now * 0.004) * 0.12;
  const breathingUrgent = 1 + Math.sin(now * 0.008) * 0.18;
  const sparkNormal = Math.sin(now * 0.02) * 0.5 + 0.5;
  const sparkUrgent = Math.sin(now * 0.04) * 0.5 + 0.5;
  const blinkIntensity = Math.sin(now * 0.02) * 0.3 + 0.7;

  bombs.forEach(bomb => {
    let bombX = bomb.moving ? bomb.pixelX : bomb.x * GRID_SIZE;
    let bombY = bomb.moving ? bomb.pixelY : bomb.y * GRID_SIZE;
    
    // Use interpolation for moving bombs
    if (bomb.moving) {
      const buffer = bombStateBuffers.current.get(bomb.id);
      if (buffer && buffer.length >= 1) {
        const renderTime = now - RENDER_DELAY;
        const interpolatedPos = interpolatePosition(buffer, renderTime, now, true);
        
        if (interpolatedPos) {
          bombX = interpolatedPos.x;
          bombY = interpolatedPos.y;
        }
      }
    }
    
    // Apply wiggle animation for gelatinous bombs
    if (bomb.gelatinous) {
      ctx.save();
      // Create a swaying motion - stronger at top, tapering to bottom
      const wiggleAngle = Math.sin(now * 0.008) * 0.15; // Oscillate between -0.15 and 0.15 radians
      const centerX = bombX + GRID_SIZE / 2;
      const centerY = bombY + GRID_SIZE; // Rotate around bottom center for jelly effect
      ctx.translate(centerX, centerY);
      ctx.rotate(wiggleAngle);
      ctx.translate(-centerX, -centerY);
    }
    
    if (bombImage) {
      // Use pre-calculated breathing animation
      const isUrgent = bomb.timer < 1000;
      const breathingScale = isUrgent ? breathingUrgent : breathingNormal;
      const scaledSize = GRID_SIZE * breathingScale;
      const offset = (GRID_SIZE - scaledSize) / 2;
      
      // Use colored bomb sprite if available and player has a color
      let bombImageToUse = bombImage;
      if (bomb.playerId !== undefined && PLAYER_COLORS[bomb.playerId] && bombSVGText) {
        const cacheKey = `bomb-${bomb.playerId}`;
        let coloredBomb = coloredBombCache.current.get(cacheKey);
        
        if (!coloredBomb) {
          coloredBomb = createColoredBomb(bombSVGText, PLAYER_COLORS[bomb.playerId]);
          if (coloredBomb) {
            coloredBombCache.current.set(cacheKey, coloredBomb);
          }
        }
        
        if (coloredBomb && coloredBomb.complete) {
          bombImageToUse = coloredBomb;
        }
      }
      
      // Draw the animated bomb sprite with breathing
      ctx.drawImage(bombImageToUse, bombX + offset, bombY + offset, scaledSize, scaledSize);
      
      // Add fuse spark flicker animation using pre-calculated values
      const sparkIntensity = isUrgent ? sparkUrgent : sparkNormal;
      if (sparkIntensity > 0.3) {
        ctx.fillStyle = `rgba(255, 69, 0, ${sparkIntensity})`;
        ctx.beginPath();
        ctx.arc(bombX + 37, bombY + 2, 2.5 + sparkIntensity * 1.5, 0, Math.PI * 2);
        ctx.fill();
        
        // Additional spark particles for larger bomb
        ctx.fillStyle = `rgba(255, 255, 0, ${sparkIntensity * 0.8})`;
        ctx.beginPath();
        ctx.arc(bombX + 39.5, bombY + 0.5, 1 + sparkIntensity * 0.5, 0, Math.PI * 2);
        ctx.fill();
      }
      
      // Add urgency effect when timer is low using pre-calculated value
      if (isUrgent) {
        ctx.fillStyle = `rgba(255, 0, 0, ${blinkIntensity * 0.3})`;
        ctx.fillRect(bombX, bombY, GRID_SIZE, GRID_SIZE);
      }
    } else {
      // Fallback to original rendering (also optimized)
      ctx.fillStyle = '#000';
      ctx.fillRect(bombX + 5, bombY + 5, GRID_SIZE - 10, GRID_SIZE - 10);
      
      const isUrgent = bomb.timer < 1000;
      const blinkSpeed = isUrgent ? 100 : 300;
      if (Math.floor(now / blinkSpeed) % 2 === 0) {
        ctx.fillStyle = '#ff0000';
        ctx.fillRect(bombX + 15, bombY + 15, GRID_SIZE - 30, GRID_SIZE - 30);
      }
    }
    
    // Restore context if we applied wiggle transformation
    if (bomb.gelatinous) {
      ctx.restore();
    }
  });
};